export enum FedopsInteractions {
  UpdateQuantity = 'update-quantity-interaction',
  RemoveItem = 'remove-item-interaction',
  ApplyCoupon = 'apply-coupon-interaction',
  AcceptUpsell = 'accept-upsell-interaction',
  ApplyRecommendation = 'apply-recommendation-interaction',
  CheckoutButtonClicked = 'checkout-button-clicked',
  lineItemsLoaded = 'line-items-loaded',
  padeLoaded = 'page-loaded',
  errorInEstimateTotalsWithShipping = 'error-in-estimate-totals-with-shipping',
  estimateTotals = 'estimate-totals',
}

export const CART_COMMANDS_URL =
  '/_api/wix-ecommerce-renderer-web/store-front/cart/{commandName}?returnCartSummary=false';

export const EMPTY_CART_ID = '00000000-000000-000000-000000000000';

export const NUMBER_OF_OPTIONS_TO_SHOW_BEFORE_COLLAPSE = 2;

export const SEPERATOR = ' - ';

export const CROSS_SELL_TITLE_MAX_CHARS = 21;
export const CROSS_SELL_DESCRIPTION_MAX_CHARS = 32;

export enum StyleParam {
  ShowContinueShopping = 'cart_showContinueShopping',
  CornerRadius = 'cartButton_cornersRadius',
  dynamicPaymentMethodsTheme = 'cartButton_dynamicPaymentMethodsTheme',
  dynamicPaymentMethodsShape = 'cartButton_dynamicPaymentMethodsShape',
  SelectedSkin = 'cartButton_selectedSkin',
  ShowCoupon = 'cart_showCoupon',
  ShowExpressCheckout = 'cart_showExpressCheckout',
  ShowBuyerNote = 'cart_showBuyerNote',
  ShowCrossSell = 'cart_showCrossSell',
  ShowTax = 'cart_showTax',
  ShowShipping = 'cart_showShipping',
  sidePaddingSliderOnDesktop = 'cart_sidePaddingSliderOnDesktop',
  Responsive = 'responsive',
  CheckoutButtonsPosition = 'mobile:cart_checkoutButtonsPosition',
  ShowCheckoutButton = 'CART_ACTION_BUTTONS_CHECKOUT_VISIBILITY',
  ShowGoToCartButton = 'CART_ACTION_BUTTONS_GO_TO_CART_VISIBILITY',
  CartItemQuantityCounterVisibility = 'CART_ITEM_QUANTITY_COUNTER_VISIBILITY',
  CartItemImageVisibility = 'CART_ITEM_IMAGE_VISIBILITY',
  CartItemInfo = 'CART_ITEM_INFO',
  CustomerInputsPromoCodeVisibility = 'CUSTOMER_INPUTS_PROMO_CODE_VISIBILITY',
  CustomerInputsNoteVisibility = 'CUSTOMER_INPUTS_NOTE_VISIBILITY',
  CartSummaryDisclaimerVisibility = 'CART_SUMMARY_DISCLAIMER_VISIBILITY',
  CartSummarySecureBadgeVisibility = 'CART_SUMMARY_SECURE_BADGE_VISIBILITY',
  cartTitleVisibility = 'CART_TITLE_VISIBILITY',
  cartNumberOfCartItemsVisibility = 'CART_NUMBER_OF_CART_ITEMS_VISIBILITY',
  CartBackground = 'cart_background',
  CartDividersColor = 'cart_dividersColor',
  CartTextColor = 'cart_textColor',
  CartTextFontStyle = 'cart_textFontStyle',
  CartTitlesColor = 'cart_titlesColor',
  CartTitlesFontStyle = 'cart_titlesFontStyle',
  CartLinksColor = 'cart_linksColor',
  CartDiscountNameColor = 'cart_discountNameColor',
  CartButtonBorderColor = 'cartButton_borderColor',
  CartButtonBackgroundColor = 'cartButton_backgroundColor',
  CartButtonTextColor = 'cartButton_textColor',
  CartButtonTextFont = 'cartButton_textFont',
  CartButtonBorderSize = 'cartButton_borderSize',
  CartItemsBackgroundColor = 'cartItemsBackgroundColor',
  CartItemsDividerColor = 'cartItemsDividerColor',
  CartItemsDividerWidth = 'cartItemsDividerWidth',
  CartItemsDividerXPadding = 'cartItemsDividerXPadding',
  CartItemsDeleteItemButtonColor = 'cartItemsDeleteItemButtonColor',
  CartItemNameFont = 'cartItemNameFont',
  CartItemNameColor = 'cartItemNameColor',
  CartItemDiscountNameFont = 'cartItemDiscountNameFont',
  CartItemDiscountNameColor = 'cartItemDiscountNameColor',
  CartItemMoreDetailsFont = 'cartItemMoreDetailsFont',
  CartItemMoreDetailsColor = 'cartItemMoreDetailsColor',
  CartHeaderBackgroundColor = 'cartHeaderBackgroundColor',
  CartHeaderDividerColor = 'cartHeaderDividerColor',
  CartHeaderDividerWidth = 'cartHeaderDividerWidth',
  CartHeaderDividerPadding = 'cartHeaderDividerPadding',
  CartTitleFont = 'cartTitleFont',
  CartTitleColor = 'cartTitleColor',
  CartSubtitleFont = 'cartSubtitleFont',
  CartSubtitleColor = 'cartSubtitleColor',
  CartCloseButtonColor = 'cartCloseButtonColor',
  CartCloseButtonSize = 'cartCloseButtonSize',
  CartItemPriceFont = 'cartItemPriceFont',
  CartItemPriceColor = 'cartItemPriceColor',
  CartItemStrikethroughPriceColor = 'cartItemStrikethroughPriceColor',
  CartItemTotalPriceFont = 'cartItemTotalPriceFont',
  CartItemTotalPriceColor = 'cartItemTotalPriceColor',
  CartItemImageBorderRadius = 'cartItemImageBorderRadius',
  CartItemQuantityBackgroundColor = 'cartItemQuantityBackgroundColor',
  CartItemQuantityBorderColor = 'cartItemQuantityBorderColor',
  CartItemQuantityBorderWidth = 'cartItemQuantityBorderWidth',
  CartItemQuantityBorderRadius = 'cartItemQuantityBorderRadius',
  CartItemQuantityFont = 'cartItemQuantityFont',
  CartItemQuantityFontColor = 'cartItemQuantityFontColor',
  CustomerInputsBackgroundColor = 'customerInputsBackgroundColor',
  CustomerInputsLinkTextFont = 'customerInputsLinkTextFont',
  CustomerInputsLinkTextFontColor = 'customerInputsLinkTextFontColor',
  CustomerInputsDividerColor = 'customerInputsDividerColor',
  CustomerInputsDividerWidth = 'customerInputsDividerWidth',
  CustomerInputsDividerXPadding = 'customerInputsDividerXPadding',
  CartSummaryBoxBackgroundColor = 'cartSummaryBoxBackgroundColor',
  CartSummaryBoxDividerColor = 'cartSummaryBoxDividerColor',
  CartSummaryBoxDividerWidth = 'cartSummaryBoxDividerWidth',
  CartSummaryBoxDividerXPadding = 'cartSummaryBoxDividerXPadding',
  CartSummaryBoxSubtotalColor = 'cartSummaryBoxSubtotalColor',
  CartSummaryBoxSubtotalFont = 'cartSummaryBoxSubtotalFont',
  CartSummaryBoxDisclaimerColor = 'cartSummaryBoxDisclaimerColor',
  CartSummaryBoxDisclaimerFont = 'cartSummaryBoxDisclaimerFont',
  CartSummaryBoxBadgeColor = 'cartSummaryBoxBadgeColor',
  GoToCartButtonBackgroundColor = 'goToCartButtonBackgroundColor',
  GoToCartButtonBorderColor = 'goToCartButtonBorderColor',
  GoToCartButtonBorderWidth = 'goToCartButtonBorderWidth',
  GoToCartButtonCornerRadius = 'goToCartButtonCornerRadius',
  GoToCartButtonFont = 'goToCartButtonFont',
  GoToCartButtonFontColor = 'goToCartButtonFontColor',
  GoToCartButtonBackgroundHoverColor = 'goToCartButtonBackgroundHoverColor',
  GoToCartButtonBorderHoverColor = 'goToCartButtonBorderHoverColor',
  GoToCartButtonTextHoverColor = 'goToCartButtonTextHoverColor',
  GoToCheckoutButtonBackgroundColor = 'goToCheckoutButtonBackgroundColor',
  GoToCheckoutButtonBorderColor = 'goToCheckoutButtonBorderColor',
  GoToCheckoutButtonBorderWidth = 'goToCheckoutButtonBorderWidth',
  GoToCheckoutButtonCornerRadius = 'goToCheckoutButtonCornerRadius',
  GoToCheckoutButtonFont = 'goToCheckoutButtonFont',
  GoToCheckoutButtonFontColor = 'goToCheckoutButtonFontColor',
  GoToCheckoutButtonBackgroundHoverColor = 'goToCheckoutButtonBackgroundHoverColor',
  GoToCheckoutButtonBorderHoverColor = 'goToCheckoutButtonBorderHoverColor',
  GoToCheckoutButtonTextHoverColor = 'goToCheckoutButtonTextHoverColor',
  CartItemVisibility = 'CART_ITEM_VISIBILITY',
  CartSummarySubtotalVisibility = 'CART_SUMMARY_SUBTOTAL_VISIBILITY',
}

export const BI_APP_NAME = 'Stores';

export const CART_ORIGIN = 'shopping cart';
export const SIDE_CART_ORIGIN = 'side cart';
export const SUCCESS_POPUP_ORIGIN = 'success popup';

export enum ContinueShoppingBiOrigin {
  shoppingCart = 'shopping cart',
  minimumOrder = 'minimum_order_cart',
}

export enum OriginTypes {
  Paypal = 'paypal',
  AddToCart = 'addToCart',
}

export const MINIMUM_ORDER_AMOUNT_NOT_REACHED = 'MINIMUM_ORDER_AMOUNT_NOT_REACHED';

export enum ShippingMethodType {
  NONE = 'none',
  PICKUP = 'store pickup',
  SHIPPING = 'shipping',
}

export enum SlotsMap {
  mainBottom = 'cart-page:main:after-1',
  SideCartHeaderAfter1 = 'side-cart:header:after-1',
  SideCartLineItemsAfter1 = 'side-cart:line-items:after-1',
  SideCartCustomerInputAfter1 = 'side-cart:customer-input:after-1',
  SideCartFooterActionsBefore1 = 'side-cart:footer:actions:before-1',
  SideCartFooterActionsAfter1 = 'side-cart:footer:actions:after-1',
}

export const MAX_DESCRIPTION_LINE_LENGTH = 500;
export const MAX_MODIFIER_LENGTH = 485;

export enum ModifierDetails {
  Quantity = 'quantity',
  Price = 'price',
  QuantityAndPrice = 'quantityAndPrice',
  Other = 'other',
}

export const ECOM_PLATFORM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';

export enum SideCartParamNames {
  CART_TITLE = 'CART_TITLE',
  CART_DISCLAIMER_TEXT = 'CART_DISCLAIMER_TEXT',
  CART_EMPTY_CART = 'CART_EMPTY_CART',
  SIDE_CART_CART_BUTTON = 'SIDE_CART_CART_BUTTON',
  SIDE_CART_CHECKOUT_BUTTON = 'SIDE_CART_CHECKOUT_BUTTON',
  SIDE_CART_ADD_PROMO_CODE_LINK = 'SIDE_CART_ADD_PROMO_CODE_LINK',
  SIDE_CART_PROMO_CODE_INPUT_PLACEHOLDER = 'SIDE_CART_PROMO_CODE_INPUT_PLACEHOLDER',
  SIDE_CART_ADD_NOTE_LINK = 'SIDE_CART_ADD_NOTE_LINK',
  SIDE_CART_INSTRUCTIONS_TEXT = 'SIDE_CART_INSTRUCTIONS_TEXT',
}

export enum CartParamNames {
  CART_TITLE = 'CART_TITLE',
  CART_EMPTY_CART = 'CART_EMPTY_CART',
  CART_CONTINUE_SHOPPING_LINK = 'CART_CONTINUE_SHOPPING_LINK',
  CART_CONTINUE_SHOPPING_LINK_OBJECT = 'CART_CONTINUE_SHOPPING_LINK_OBJECT',
  CART_ADD_NOTE_LINK = 'CART_ADD_NOTE_LINK',
  CART_INSTRUCTIONS_TEXT = 'CART_INSTRUCTIONS_TEXT',
  CART_ADD_PROMO_CODE_LINK = 'CART_ADD_PROMO_CODE_LINK',
  CART_BUTTON_TEXT = 'CART_BUTTON_TEXT',
  CART_V2_DISCLAIMER = 'CART_V2_DISCLAIMER',
}
